<template>
  <a-modal
    :visible="visible"
    centered
    title="Revoke License"
    :closable="!loading"
    :maskClosable="!loading"
    @cancel="handleCancel"
  >
    <div class="py-2">
      <a-alert
        type="warning"
        class="mb-3"
        message="Warning"
        description="The device will no longer be able to use Assembly Copilot after the license is revoked."
        show-icon
      />
      <p>Are you sure you want to revoke the license from this device?</p>
      <div class="device-info mt-3 p-3 bg-light rounded">
        <div class="d-flex mb-2">
          <span class="text-muted" style="width: 120px">Display Name:</span>
          <strong>{{ device?.display_name || device?.device_name || '-' }}</strong>
        </div>
        <div class="d-flex mb-2">
          <span class="text-muted" style="width: 120px">Serial Number:</span>
          <strong>{{ device?.serial_number || '-' }}</strong>
        </div>
        <div class="d-flex">
          <span class="text-muted" style="width: 120px">Assigned By:</span>
          <strong>{{ device?.assigned_by || '-' }}</strong>
        </div>
      </div>
    </div>
    <template #footer>
      <a-button :disabled="loading" @click="handleCancel">Cancel</a-button>
      <a-button type="primary" danger :loading="loading" @click="handleConfirm">
        Revoke License
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'RevokeLicenseModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible', 'confirm'],
  methods: {
    handleCancel() {
      if (!this.loading) {
        this.$emit('update:visible', false);
      }
    },
    handleConfirm() {
      this.$emit('confirm', this.device);
    },
  },
};
</script>

<style scoped>
.device-info {
  background-color: #f5f5f5;
}
</style>
